/**
 * §25.7 — Atlas kartındaki `**kalın**` vurgularını ayrıştırır.
 *
 * KARAR: markdown kütüphanesi EKLENMEZ. Anlatı metni yalnız TEK bir işaretleme
 * kullanır (§25.4 sistem prompt sözleşmesi: "en önemli 1-2 vurgu **kalın**"), tam
 * markdown ayrıştırıcısı hem gereksiz bağımlılık hem de HTML enjeksiyonu yüzeyidir.
 * Burada üretilen parçalar React tarafında METİN olarak render edilir — `innerHTML`
 * kullanılmaz, dolayısıyla anlatı içeriği asla HTML olarak yorumlanmaz.
 */

export interface BoldSegment {
  text: string;
  bold: boolean;
}

/** `**...**` çiftlerini ayırır; eşleşmeyen `**` düz metin sayılır. */
export function parseBold(input: string): BoldSegment[] {
  const out: BoldSegment[] = [];
  let i = 0;

  while (i < input.length) {
    const open = input.indexOf('**', i);
    if (open === -1) break;
    const close = input.indexOf('**', open + 2);
    // Kapanışı olmayan `**` vurgu DEĞİLDİR — olduğu gibi metne girer.
    if (close === -1) break;

    if (open > i) out.push({ text: input.slice(i, open), bold: false });
    const icerik = input.slice(open + 2, close);
    // Boş vurgu (`****`) anlamsızdır; düz metin olarak korunur.
    if (icerik === '') out.push({ text: '****', bold: false });
    else out.push({ text: icerik, bold: true });
    i = close + 2;
  }

  if (i < input.length) out.push({ text: input.slice(i), bold: false });
  return out.filter((s) => s.text !== '');
}
